<template>
  <div class="auth-form">
    <p class="auth-lead mb-3">Přezdívka, e-mail a telefon</p>
    <argon-alert
      v-for="msg in store.state.alert.message"
      :key="msg"
      v-show="store.state.alert.type == 'danger'"
      class="text-sm text-center mb-3"
      icon="fa-solid fa-triangle-exclamation"
      :color="store.state.alert.type"
    >
      {{ msg }}
    </argon-alert>
    <form @submit.prevent="userRegistration">
      <div class="mb-3">
        <input
          ref="firstInput"
          v-model="credentials.username"
          type="text"
          class="form-control form-control-lg"
          placeholder="Přezdívka"
          name="username"
          autocomplete="off"
        />
      </div>
      <div class="mb-3">
        <input
          v-model="credentials.email"
          type="email"
          class="form-control form-control-lg"
          placeholder="E-mail"
          name="email"
          autocomplete="off"
        />
      </div>
      <div class="mb-3">
        <input
          v-model="credentials.phone"
          type="tel"
          class="form-control form-control-lg"
          placeholder="Telefon"
          name="phoneNumber"
          autocomplete="off"
        />
      </div>
      <argon-button
        class="mt-2"
        color="primary"
        size="lg"
        :disabled="isButtonLoading"
        fullWidth
      >
        <span v-if="isButtonLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Registrovat
      </argon-button>
    </form>
    <div class="pt-3 text-center">
      <p class="text-sm mb-0">
        Máš již účet?
        <a
          class="text-primary font-weight-bolder"
          @click="store.state.showForm = 'login'"
          href="javascript:;"
        >Přihlaš se</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, inject, ref, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import authService from "@/services/authService.js";

const store = useStore();
const swal = inject('$swal');
const firstInput = ref(null);

const initialCredentials = {
  username: '',
  email: '',
  phone: '',
};
const credentials = reactive({ ...initialCredentials });
const isButtonLoading = computed(() => store.getters['loadingModule/isButtonLoading']);

onMounted(() => {
  nextTick(() => firstInput.value?.focus());
});

const userRegistration = async () => {
  try {   
    store.dispatch('loadingModule/setButtonLoading', true);
    const response = await authService.Registration(credentials);

    if (response.Result) {
      store.commit('toggleAuthModal');
      swal.fire({
        position: 'center',
        icon: 'success',
        html: `<h5>${response.InfoMessage[0]}</h5>` + `<p class="text-center px-5">${response.InfoMessage[1]}</p>`,
        showConfirmButton: false,
        timer: 3000,
      })
    } else {
      store.dispatch('alertError', response.ErrorMessage);
    }
  } catch (error) {
    console.error(error);
  } finally {
    store.dispatch('loadingModule/setButtonLoading', false);
  }
};
</script>

<style scoped>
.auth-lead {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #64748B;
}
</style>
